import { Routes, RouterModule } from "@angular/router";

import { SOTLayoutComponent } from "./layout/sotLayout/sotLayout.component";
import * as Components from './components';

// SOT layout routes goes here
const sotRoutes: Routes = [{
  path: "sot", component: SOTLayoutComponent,
  children: [
    { path: "", component: Components.InitpageComponent },
    { path: "userprofil", component: Components.UserProfil },
    { path: "splashscreen", component: Components.SplashscreenComponent },
    { path: "ordertype", component: Components.OrderTypeComponent },
    { path: "menu", component: Components.MenuComponent },
    { path: "product", component: Components.ProductComponent },
    { path: "recipelink", component: Components.RecipeLinkComponent },
    { path: "checkout", component: Components.CheckoutComponent },
    { path: "cardscan", component: Components.StartCardscanComponent },
    { path: "pager", component: Components.PagerComponent },
    { path: "pagerconfirmation", component: Components.PagerConfirmationComponent },
    { path: "ordercardscan", component: Components.CardscanComponent },
    { path: "payment", component: Components.PaymentComponent },
    { path: "paymentconfirmation", component: Components.PaymentConfirmationComponent },
    { path: "coupon", component: Components.CouponComponent },
    { path: "outoforder", component: Components.OutofOrderComponent },
    { path: "error", component: Components.ErrorpageComponent },
    { path: "**", component: Components.ErrorpageComponent }
  ]
}];

export const routing = RouterModule.forChild(sotRoutes);